export default function PackageCart(props) {
    return (<svg xmlns="http://www.w3.org/2000/svg" width="10.641" height="9.618" viewBox="0 0 10.641 9.618">
        <path id="Path_15157" data-name="Path 15157" d="M9.878,36.092,6.13,32.235a.415.415,0,0,0-.711.3v1.716A5.657,5.657,0,0,0,.263,38.406,6.9,6.9,0,0,0,0,40.556c0,.083,0,.106,0,.124A.415.415,0,0,0,.78,40.9a6.536,6.536,0,0,1,1.568-1.88,4.194,4.194,0,0,1,3.071-.971v2.2a.415.415,0,0,0,.711.3L9.878,36.7A.437.437,0,0,0,9.878,36.092Z" transform="translate(0.3 -31.799)" fill={props.color2} stroke={props.color1} stroke-width="0.6" />
    </svg>
    )
}


